module.exports = __webpack_public_path__ + "static/media/success-grey.fb845f1d.svg";